export const rolePermissions = {
  "Admin": {
    1: [1, 2, 3, 4], // Reset Password
    2: [1, 2, 3,4],     // Masters
    3: [1, 3,],        // Manage Users
    4: [1, 3], // Assets
    5: [1,2, 3,4],        // Reports
    6: [1,2,3,4]  ,          // Audit Log
    7: [1,2,3,4] ,
    8: [1,2,3,4] ,
    9: [1,2,3,4] ,
    10:[1,2,3,4] ,
  },
  "MaintenanceManager" : {
    1: [1,2,3],
    2: [1,2,3],
    3: [1],
    4: [1],
    // 5: [1],
    // 6: [1]
  },
  "MaintenanceUser": {
    1: [1,3],
    2: [1,3],
    3: [1,3],
    4: [1],
    5: [],
    6: []
  }
};
